import React, {Component} from 'react';

import {connect} from 'react-redux';
import {createSelector} from 'reselect';
import {bindDispatch} from 'app/utils/redux';

import * as routePath from 'app/utils/routePath';
import {history} from 'store';

import DashboardView from 'views/dashboard';

class DashboardContainer extends Component {

  componentWillMount() {
    let {routing: {location: {pathname = routePath.rootRoute} = {} } = {}, entity, actions} = this.props;

    if (pathname === routePath.rootRoute) {
      history.push(routePath.dashboardRoute);
      // since history.push(routePath.dashboardRoute) call in layout is not updating the state
    }
    actions.fetchRecentEntities();
    actions.fetchEntitiesCount();
    actions.fetchEntitiesCount(entity.timePeriod.selected);
  }

  render() {

  	let {entity, academy, candidates, actions} = this.props;

    return (
      <div className='mx4 my3 container'>
        <DashboardView
          entity={entity} 
        	academy={academy} 
        	candidates={candidates}
        	setTimePeriod={actions.setTimePeriod}
        	fetchEntitiesCount={actions.fetchEntitiesCount}/>
      </div>
    );

  }
}

const selector = createSelector(
  state => state.entity,
  state => state.academy,
  state => state.candidates,
  state => state.routing,
  (entity, academy, candidates, routing) => ({ entity, academy, candidates, routing })
);

export default connect(selector, bindDispatch)(DashboardContainer);



// WEBPACK FOOTER //
// ./src/containers/DashboardContainer.js